/**
 * @fileoverview gRPC-Web generated client stub for authepb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.23.4
// source: external/auth/auth.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var xcommon_common_pb = require('../../xcommon/common_pb.js')

var xcommon_enum_pb = require('../../xcommon/enum_pb.js')

var xcommon_module_pb = require('../../xcommon/module_pb.js')
const proto = {};
proto.authepb = require('./auth_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.authepb.AuthServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.authepb.AuthServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.CreateUserGroupReq,
 *   !proto.authepb.CreateUserGroupResp>}
 */
const methodDescriptor_AuthService_CreateUserGroup = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/CreateUserGroup',
  grpc.web.MethodType.UNARY,
  proto.authepb.CreateUserGroupReq,
  proto.authepb.CreateUserGroupResp,
  /**
   * @param {!proto.authepb.CreateUserGroupReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authepb.CreateUserGroupResp.deserializeBinary
);


/**
 * @param {!proto.authepb.CreateUserGroupReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authepb.CreateUserGroupResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authepb.CreateUserGroupResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.createUserGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/CreateUserGroup',
      request,
      metadata || {},
      methodDescriptor_AuthService_CreateUserGroup,
      callback);
};


/**
 * @param {!proto.authepb.CreateUserGroupReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authepb.CreateUserGroupResp>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.createUserGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/CreateUserGroup',
      request,
      metadata || {},
      methodDescriptor_AuthService_CreateUserGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.RenameUserGroupReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_AuthService_RenameUserGroup = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/RenameUserGroup',
  grpc.web.MethodType.UNARY,
  proto.authepb.RenameUserGroupReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.authepb.RenameUserGroupReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.authepb.RenameUserGroupReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.renameUserGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/RenameUserGroup',
      request,
      metadata || {},
      methodDescriptor_AuthService_RenameUserGroup,
      callback);
};


/**
 * @param {!proto.authepb.RenameUserGroupReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.renameUserGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/RenameUserGroup',
      request,
      metadata || {},
      methodDescriptor_AuthService_RenameUserGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.DeleteUserGroupReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_AuthService_DeleteUserGroup = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/DeleteUserGroup',
  grpc.web.MethodType.UNARY,
  proto.authepb.DeleteUserGroupReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.authepb.DeleteUserGroupReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.authepb.DeleteUserGroupReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.deleteUserGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/DeleteUserGroup',
      request,
      metadata || {},
      methodDescriptor_AuthService_DeleteUserGroup,
      callback);
};


/**
 * @param {!proto.authepb.DeleteUserGroupReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.deleteUserGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/DeleteUserGroup',
      request,
      metadata || {},
      methodDescriptor_AuthService_DeleteUserGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CommonIn,
 *   !proto.xcommon.TreeResp>}
 */
const methodDescriptor_AuthService_GetUserGroupTree = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/GetUserGroupTree',
  grpc.web.MethodType.UNARY,
  xcommon_common_pb.CommonIn,
  xcommon_module_pb.TreeResp,
  /**
   * @param {!proto.xcommon.CommonIn} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_module_pb.TreeResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CommonIn} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.TreeResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.TreeResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.getUserGroupTree =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/GetUserGroupTree',
      request,
      metadata || {},
      methodDescriptor_AuthService_GetUserGroupTree,
      callback);
};


/**
 * @param {!proto.xcommon.CommonIn} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.TreeResp>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.getUserGroupTree =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/GetUserGroupTree',
      request,
      metadata || {},
      methodDescriptor_AuthService_GetUserGroupTree);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CommonIn,
 *   !proto.authepb.ListUserGroupResp>}
 */
const methodDescriptor_AuthService_ListUserGroup = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/ListUserGroup',
  grpc.web.MethodType.UNARY,
  xcommon_common_pb.CommonIn,
  proto.authepb.ListUserGroupResp,
  /**
   * @param {!proto.xcommon.CommonIn} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authepb.ListUserGroupResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CommonIn} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authepb.ListUserGroupResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authepb.ListUserGroupResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.listUserGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/ListUserGroup',
      request,
      metadata || {},
      methodDescriptor_AuthService_ListUserGroup,
      callback);
};


/**
 * @param {!proto.xcommon.CommonIn} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authepb.ListUserGroupResp>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.listUserGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/ListUserGroup',
      request,
      metadata || {},
      methodDescriptor_AuthService_ListUserGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.ListUserGroupByTypeReq,
 *   !proto.authepb.ListUserGroupResp>}
 */
const methodDescriptor_AuthService_ListUserGroupByType = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/ListUserGroupByType',
  grpc.web.MethodType.UNARY,
  proto.authepb.ListUserGroupByTypeReq,
  proto.authepb.ListUserGroupResp,
  /**
   * @param {!proto.authepb.ListUserGroupByTypeReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authepb.ListUserGroupResp.deserializeBinary
);


/**
 * @param {!proto.authepb.ListUserGroupByTypeReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authepb.ListUserGroupResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authepb.ListUserGroupResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.listUserGroupByType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/ListUserGroupByType',
      request,
      metadata || {},
      methodDescriptor_AuthService_ListUserGroupByType,
      callback);
};


/**
 * @param {!proto.authepb.ListUserGroupByTypeReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authepb.ListUserGroupResp>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.listUserGroupByType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/ListUserGroupByType',
      request,
      metadata || {},
      methodDescriptor_AuthService_ListUserGroupByType);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.ListUserGroupByMutiTypeReq,
 *   !proto.authepb.ListUserGroupResp>}
 */
const methodDescriptor_AuthService_ListUserGroupByMutiType = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/ListUserGroupByMutiType',
  grpc.web.MethodType.UNARY,
  proto.authepb.ListUserGroupByMutiTypeReq,
  proto.authepb.ListUserGroupResp,
  /**
   * @param {!proto.authepb.ListUserGroupByMutiTypeReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authepb.ListUserGroupResp.deserializeBinary
);


/**
 * @param {!proto.authepb.ListUserGroupByMutiTypeReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authepb.ListUserGroupResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authepb.ListUserGroupResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.listUserGroupByMutiType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/ListUserGroupByMutiType',
      request,
      metadata || {},
      methodDescriptor_AuthService_ListUserGroupByMutiType,
      callback);
};


/**
 * @param {!proto.authepb.ListUserGroupByMutiTypeReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authepb.ListUserGroupResp>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.listUserGroupByMutiType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/ListUserGroupByMutiType',
      request,
      metadata || {},
      methodDescriptor_AuthService_ListUserGroupByMutiType);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.ChangeUserGroupInRoleReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_AuthService_ChangeUserGroupInRole = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/ChangeUserGroupInRole',
  grpc.web.MethodType.UNARY,
  proto.authepb.ChangeUserGroupInRoleReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.authepb.ChangeUserGroupInRoleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.authepb.ChangeUserGroupInRoleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.changeUserGroupInRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/ChangeUserGroupInRole',
      request,
      metadata || {},
      methodDescriptor_AuthService_ChangeUserGroupInRole,
      callback);
};


/**
 * @param {!proto.authepb.ChangeUserGroupInRoleReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.changeUserGroupInRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/ChangeUserGroupInRole',
      request,
      metadata || {},
      methodDescriptor_AuthService_ChangeUserGroupInRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.GetUserGroupTreeByRoleIDReq,
 *   !proto.authepb.GetUserGroupTreeByRoleIDResp>}
 */
const methodDescriptor_AuthService_GetUserGroupTreeByRoleID = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/GetUserGroupTreeByRoleID',
  grpc.web.MethodType.UNARY,
  proto.authepb.GetUserGroupTreeByRoleIDReq,
  proto.authepb.GetUserGroupTreeByRoleIDResp,
  /**
   * @param {!proto.authepb.GetUserGroupTreeByRoleIDReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authepb.GetUserGroupTreeByRoleIDResp.deserializeBinary
);


/**
 * @param {!proto.authepb.GetUserGroupTreeByRoleIDReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authepb.GetUserGroupTreeByRoleIDResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authepb.GetUserGroupTreeByRoleIDResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.getUserGroupTreeByRoleID =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/GetUserGroupTreeByRoleID',
      request,
      metadata || {},
      methodDescriptor_AuthService_GetUserGroupTreeByRoleID,
      callback);
};


/**
 * @param {!proto.authepb.GetUserGroupTreeByRoleIDReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authepb.GetUserGroupTreeByRoleIDResp>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.getUserGroupTreeByRoleID =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/GetUserGroupTreeByRoleID',
      request,
      metadata || {},
      methodDescriptor_AuthService_GetUserGroupTreeByRoleID);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.CreateRoleReq,
 *   !proto.authepb.CreateRoleResp>}
 */
const methodDescriptor_AuthService_CreateRole = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/CreateRole',
  grpc.web.MethodType.UNARY,
  proto.authepb.CreateRoleReq,
  proto.authepb.CreateRoleResp,
  /**
   * @param {!proto.authepb.CreateRoleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authepb.CreateRoleResp.deserializeBinary
);


/**
 * @param {!proto.authepb.CreateRoleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authepb.CreateRoleResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authepb.CreateRoleResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.createRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/CreateRole',
      request,
      metadata || {},
      methodDescriptor_AuthService_CreateRole,
      callback);
};


/**
 * @param {!proto.authepb.CreateRoleReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authepb.CreateRoleResp>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.createRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/CreateRole',
      request,
      metadata || {},
      methodDescriptor_AuthService_CreateRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.UpdateRoleReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_AuthService_UpdateRole = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/UpdateRole',
  grpc.web.MethodType.UNARY,
  proto.authepb.UpdateRoleReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.authepb.UpdateRoleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.authepb.UpdateRoleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.updateRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/UpdateRole',
      request,
      metadata || {},
      methodDescriptor_AuthService_UpdateRole,
      callback);
};


/**
 * @param {!proto.authepb.UpdateRoleReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.updateRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/UpdateRole',
      request,
      metadata || {},
      methodDescriptor_AuthService_UpdateRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.DeleteRoleReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_AuthService_DeleteRole = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/DeleteRole',
  grpc.web.MethodType.UNARY,
  proto.authepb.DeleteRoleReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.authepb.DeleteRoleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.authepb.DeleteRoleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.deleteRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/DeleteRole',
      request,
      metadata || {},
      methodDescriptor_AuthService_DeleteRole,
      callback);
};


/**
 * @param {!proto.authepb.DeleteRoleReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.deleteRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/DeleteRole',
      request,
      metadata || {},
      methodDescriptor_AuthService_DeleteRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CommonIn,
 *   !proto.authepb.ListRoleResp>}
 */
const methodDescriptor_AuthService_ListRole = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/ListRole',
  grpc.web.MethodType.UNARY,
  xcommon_common_pb.CommonIn,
  proto.authepb.ListRoleResp,
  /**
   * @param {!proto.xcommon.CommonIn} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authepb.ListRoleResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CommonIn} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authepb.ListRoleResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authepb.ListRoleResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.listRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/ListRole',
      request,
      metadata || {},
      methodDescriptor_AuthService_ListRole,
      callback);
};


/**
 * @param {!proto.xcommon.CommonIn} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authepb.ListRoleResp>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.listRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/ListRole',
      request,
      metadata || {},
      methodDescriptor_AuthService_ListRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.CreatePermReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_AuthService_CreatePerm = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/CreatePerm',
  grpc.web.MethodType.UNARY,
  proto.authepb.CreatePermReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.authepb.CreatePermReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.authepb.CreatePermReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.createPerm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/CreatePerm',
      request,
      metadata || {},
      methodDescriptor_AuthService_CreatePerm,
      callback);
};


/**
 * @param {!proto.authepb.CreatePermReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.createPerm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/CreatePerm',
      request,
      metadata || {},
      methodDescriptor_AuthService_CreatePerm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.UpdatePermReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_AuthService_UpdatePerm = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/UpdatePerm',
  grpc.web.MethodType.UNARY,
  proto.authepb.UpdatePermReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.authepb.UpdatePermReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.authepb.UpdatePermReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.updatePerm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/UpdatePerm',
      request,
      metadata || {},
      methodDescriptor_AuthService_UpdatePerm,
      callback);
};


/**
 * @param {!proto.authepb.UpdatePermReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.updatePerm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/UpdatePerm',
      request,
      metadata || {},
      methodDescriptor_AuthService_UpdatePerm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.DeletePermReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_AuthService_DeletePerm = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/DeletePerm',
  grpc.web.MethodType.UNARY,
  proto.authepb.DeletePermReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.authepb.DeletePermReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.authepb.DeletePermReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.deletePerm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/DeletePerm',
      request,
      metadata || {},
      methodDescriptor_AuthService_DeletePerm,
      callback);
};


/**
 * @param {!proto.authepb.DeletePermReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.deletePerm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/DeletePerm',
      request,
      metadata || {},
      methodDescriptor_AuthService_DeletePerm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CommonIn,
 *   !proto.xcommon.TreeResp>}
 */
const methodDescriptor_AuthService_GetMenuTree = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/GetMenuTree',
  grpc.web.MethodType.UNARY,
  xcommon_common_pb.CommonIn,
  xcommon_module_pb.TreeResp,
  /**
   * @param {!proto.xcommon.CommonIn} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_module_pb.TreeResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CommonIn} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.TreeResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.TreeResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.getMenuTree =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/GetMenuTree',
      request,
      metadata || {},
      methodDescriptor_AuthService_GetMenuTree,
      callback);
};


/**
 * @param {!proto.xcommon.CommonIn} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.TreeResp>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.getMenuTree =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/GetMenuTree',
      request,
      metadata || {},
      methodDescriptor_AuthService_GetMenuTree);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.GetMenuTreeByRoleReq,
 *   !proto.xcommon.TreeResp>}
 */
const methodDescriptor_AuthService_GetMenuTreeByRole = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/GetMenuTreeByRole',
  grpc.web.MethodType.UNARY,
  proto.authepb.GetMenuTreeByRoleReq,
  xcommon_module_pb.TreeResp,
  /**
   * @param {!proto.authepb.GetMenuTreeByRoleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_module_pb.TreeResp.deserializeBinary
);


/**
 * @param {!proto.authepb.GetMenuTreeByRoleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.TreeResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.TreeResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.getMenuTreeByRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/GetMenuTreeByRole',
      request,
      metadata || {},
      methodDescriptor_AuthService_GetMenuTreeByRole,
      callback);
};


/**
 * @param {!proto.authepb.GetMenuTreeByRoleReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.TreeResp>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.getMenuTreeByRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/GetMenuTreeByRole',
      request,
      metadata || {},
      methodDescriptor_AuthService_GetMenuTreeByRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.GetDataPermSummaryByRoleReq,
 *   !proto.xcommon.TreeResp>}
 */
const methodDescriptor_AuthService_GetDataPermSummaryByRole = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/GetDataPermSummaryByRole',
  grpc.web.MethodType.UNARY,
  proto.authepb.GetDataPermSummaryByRoleReq,
  xcommon_module_pb.TreeResp,
  /**
   * @param {!proto.authepb.GetDataPermSummaryByRoleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_module_pb.TreeResp.deserializeBinary
);


/**
 * @param {!proto.authepb.GetDataPermSummaryByRoleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.TreeResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.TreeResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.getDataPermSummaryByRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/GetDataPermSummaryByRole',
      request,
      metadata || {},
      methodDescriptor_AuthService_GetDataPermSummaryByRole,
      callback);
};


/**
 * @param {!proto.authepb.GetDataPermSummaryByRoleReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.TreeResp>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.getDataPermSummaryByRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/GetDataPermSummaryByRole',
      request,
      metadata || {},
      methodDescriptor_AuthService_GetDataPermSummaryByRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.GetPermSummaryByUserGroupReq,
 *   !proto.xcommon.TreeResp>}
 */
const methodDescriptor_AuthService_GetPermSummaryByUserGroup = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/GetPermSummaryByUserGroup',
  grpc.web.MethodType.UNARY,
  proto.authepb.GetPermSummaryByUserGroupReq,
  xcommon_module_pb.TreeResp,
  /**
   * @param {!proto.authepb.GetPermSummaryByUserGroupReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_module_pb.TreeResp.deserializeBinary
);


/**
 * @param {!proto.authepb.GetPermSummaryByUserGroupReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.TreeResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.TreeResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.getPermSummaryByUserGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/GetPermSummaryByUserGroup',
      request,
      metadata || {},
      methodDescriptor_AuthService_GetPermSummaryByUserGroup,
      callback);
};


/**
 * @param {!proto.authepb.GetPermSummaryByUserGroupReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.TreeResp>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.getPermSummaryByUserGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/GetPermSummaryByUserGroup',
      request,
      metadata || {},
      methodDescriptor_AuthService_GetPermSummaryByUserGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.GetDataPermTreeByUserGroupReq,
 *   !proto.authepb.GetDataPermTreeByUserGroupResp>}
 */
const methodDescriptor_AuthService_GetDataPermTreeByUserGroup = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/GetDataPermTreeByUserGroup',
  grpc.web.MethodType.UNARY,
  proto.authepb.GetDataPermTreeByUserGroupReq,
  proto.authepb.GetDataPermTreeByUserGroupResp,
  /**
   * @param {!proto.authepb.GetDataPermTreeByUserGroupReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authepb.GetDataPermTreeByUserGroupResp.deserializeBinary
);


/**
 * @param {!proto.authepb.GetDataPermTreeByUserGroupReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authepb.GetDataPermTreeByUserGroupResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authepb.GetDataPermTreeByUserGroupResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.getDataPermTreeByUserGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/GetDataPermTreeByUserGroup',
      request,
      metadata || {},
      methodDescriptor_AuthService_GetDataPermTreeByUserGroup,
      callback);
};


/**
 * @param {!proto.authepb.GetDataPermTreeByUserGroupReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authepb.GetDataPermTreeByUserGroupResp>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.getDataPermTreeByUserGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/GetDataPermTreeByUserGroup',
      request,
      metadata || {},
      methodDescriptor_AuthService_GetDataPermTreeByUserGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.BatchAssignPermToRoleReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_AuthService_BatchAssignPermToRole = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/BatchAssignPermToRole',
  grpc.web.MethodType.UNARY,
  proto.authepb.BatchAssignPermToRoleReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.authepb.BatchAssignPermToRoleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.authepb.BatchAssignPermToRoleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.batchAssignPermToRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/BatchAssignPermToRole',
      request,
      metadata || {},
      methodDescriptor_AuthService_BatchAssignPermToRole,
      callback);
};


/**
 * @param {!proto.authepb.BatchAssignPermToRoleReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.batchAssignPermToRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/BatchAssignPermToRole',
      request,
      metadata || {},
      methodDescriptor_AuthService_BatchAssignPermToRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.BatchAssignDataPermReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_AuthService_BatchAssignDataPermToUserGroup = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/BatchAssignDataPermToUserGroup',
  grpc.web.MethodType.UNARY,
  proto.authepb.BatchAssignDataPermReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.authepb.BatchAssignDataPermReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.authepb.BatchAssignDataPermReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.batchAssignDataPermToUserGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/BatchAssignDataPermToUserGroup',
      request,
      metadata || {},
      methodDescriptor_AuthService_BatchAssignDataPermToUserGroup,
      callback);
};


/**
 * @param {!proto.authepb.BatchAssignDataPermReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.batchAssignDataPermToUserGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/BatchAssignDataPermToUserGroup',
      request,
      metadata || {},
      methodDescriptor_AuthService_BatchAssignDataPermToUserGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.CreateResourceReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_AuthService_CreateResource = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/CreateResource',
  grpc.web.MethodType.UNARY,
  proto.authepb.CreateResourceReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.authepb.CreateResourceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.authepb.CreateResourceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.createResource =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/CreateResource',
      request,
      metadata || {},
      methodDescriptor_AuthService_CreateResource,
      callback);
};


/**
 * @param {!proto.authepb.CreateResourceReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.createResource =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/CreateResource',
      request,
      metadata || {},
      methodDescriptor_AuthService_CreateResource);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.UpdateResourceReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_AuthService_UpdateResource = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/UpdateResource',
  grpc.web.MethodType.UNARY,
  proto.authepb.UpdateResourceReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.authepb.UpdateResourceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.authepb.UpdateResourceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.updateResource =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/UpdateResource',
      request,
      metadata || {},
      methodDescriptor_AuthService_UpdateResource,
      callback);
};


/**
 * @param {!proto.authepb.UpdateResourceReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.updateResource =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/UpdateResource',
      request,
      metadata || {},
      methodDescriptor_AuthService_UpdateResource);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.DeleteResourceReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_AuthService_DeleteResource = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/DeleteResource',
  grpc.web.MethodType.UNARY,
  proto.authepb.DeleteResourceReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.authepb.DeleteResourceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.authepb.DeleteResourceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.deleteResource =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/DeleteResource',
      request,
      metadata || {},
      methodDescriptor_AuthService_DeleteResource,
      callback);
};


/**
 * @param {!proto.authepb.DeleteResourceReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.deleteResource =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/DeleteResource',
      request,
      metadata || {},
      methodDescriptor_AuthService_DeleteResource);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.ListResourceReq,
 *   !proto.authepb.ListResourceResp>}
 */
const methodDescriptor_AuthService_ListResource = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/ListResource',
  grpc.web.MethodType.UNARY,
  proto.authepb.ListResourceReq,
  proto.authepb.ListResourceResp,
  /**
   * @param {!proto.authepb.ListResourceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authepb.ListResourceResp.deserializeBinary
);


/**
 * @param {!proto.authepb.ListResourceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authepb.ListResourceResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authepb.ListResourceResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.listResource =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/ListResource',
      request,
      metadata || {},
      methodDescriptor_AuthService_ListResource,
      callback);
};


/**
 * @param {!proto.authepb.ListResourceReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authepb.ListResourceResp>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.listResource =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/ListResource',
      request,
      metadata || {},
      methodDescriptor_AuthService_ListResource);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.GetResourceByPermReq,
 *   !proto.authepb.ListResourcePermResp>}
 */
const methodDescriptor_AuthService_GetResourceByPerm = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/GetResourceByPerm',
  grpc.web.MethodType.UNARY,
  proto.authepb.GetResourceByPermReq,
  proto.authepb.ListResourcePermResp,
  /**
   * @param {!proto.authepb.GetResourceByPermReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authepb.ListResourcePermResp.deserializeBinary
);


/**
 * @param {!proto.authepb.GetResourceByPermReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authepb.ListResourcePermResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authepb.ListResourcePermResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.getResourceByPerm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/GetResourceByPerm',
      request,
      metadata || {},
      methodDescriptor_AuthService_GetResourceByPerm,
      callback);
};


/**
 * @param {!proto.authepb.GetResourceByPermReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authepb.ListResourcePermResp>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.getResourceByPerm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/GetResourceByPerm',
      request,
      metadata || {},
      methodDescriptor_AuthService_GetResourceByPerm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.AssignResourceToPermReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_AuthService_AssignResourceToPerm = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/AssignResourceToPerm',
  grpc.web.MethodType.UNARY,
  proto.authepb.AssignResourceToPermReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.authepb.AssignResourceToPermReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.authepb.AssignResourceToPermReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.assignResourceToPerm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/AssignResourceToPerm',
      request,
      metadata || {},
      methodDescriptor_AuthService_AssignResourceToPerm,
      callback);
};


/**
 * @param {!proto.authepb.AssignResourceToPermReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.assignResourceToPerm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/AssignResourceToPerm',
      request,
      metadata || {},
      methodDescriptor_AuthService_AssignResourceToPerm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.DeleteResourceFromPermReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_AuthService_DeleteResourceFromPerm = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/DeleteResourceFromPerm',
  grpc.web.MethodType.UNARY,
  proto.authepb.DeleteResourceFromPermReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.authepb.DeleteResourceFromPermReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.authepb.DeleteResourceFromPermReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.deleteResourceFromPerm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/DeleteResourceFromPerm',
      request,
      metadata || {},
      methodDescriptor_AuthService_DeleteResourceFromPerm,
      callback);
};


/**
 * @param {!proto.authepb.DeleteResourceFromPermReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.deleteResourceFromPerm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/DeleteResourceFromPerm',
      request,
      metadata || {},
      methodDescriptor_AuthService_DeleteResourceFromPerm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.UpdateResourcePermBindingReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_AuthService_UpdateResourcePermBinding = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/UpdateResourcePermBinding',
  grpc.web.MethodType.UNARY,
  proto.authepb.UpdateResourcePermBindingReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.authepb.UpdateResourcePermBindingReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.authepb.UpdateResourcePermBindingReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.updateResourcePermBinding =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/UpdateResourcePermBinding',
      request,
      metadata || {},
      methodDescriptor_AuthService_UpdateResourcePermBinding,
      callback);
};


/**
 * @param {!proto.authepb.UpdateResourcePermBindingReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.updateResourcePermBinding =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/UpdateResourcePermBinding',
      request,
      metadata || {},
      methodDescriptor_AuthService_UpdateResourcePermBinding);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authepb.GsiReq,
 *   !proto.authepb.GsiResp>}
 */
const methodDescriptor_AuthService_Gsi = new grpc.web.MethodDescriptor(
  '/authepb.AuthService/Gsi',
  grpc.web.MethodType.UNARY,
  proto.authepb.GsiReq,
  proto.authepb.GsiResp,
  /**
   * @param {!proto.authepb.GsiReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authepb.GsiResp.deserializeBinary
);


/**
 * @param {!proto.authepb.GsiReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authepb.GsiResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authepb.GsiResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authepb.AuthServiceClient.prototype.gsi =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authepb.AuthService/Gsi',
      request,
      metadata || {},
      methodDescriptor_AuthService_Gsi,
      callback);
};


/**
 * @param {!proto.authepb.GsiReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authepb.GsiResp>}
 *     Promise that resolves to the response
 */
proto.authepb.AuthServicePromiseClient.prototype.gsi =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authepb.AuthService/Gsi',
      request,
      metadata || {},
      methodDescriptor_AuthService_Gsi);
};


module.exports = proto.authepb;

